import type { FieldValues, Path, UseFormSetError } from 'react-hook-form';
import { fieldErrorsOf } from './field-errors';

export interface ProblemErrorMapping {
  /** Path prefixes rewritten before matching (`{ 'settings.': '' }` lifts nested settings). */
  rename?: Record<string, string>;
  /** Form field roots that may receive an error (`name`, `portalCategories`). */
  known: readonly string[];
}

/**
 * Pushes problem+json `errors[]` onto a react-hook-form form for the fields it renders and
 * returns the original paths that were mapped (so the banner can omit them).
 */
export function applyProblemErrors<T extends FieldValues>(
  error: unknown,
  setError: UseFormSetError<T>,
  mapping: ProblemErrorMapping,
): Set<string> {
  const mapped = new Set<string>();
  for (const fieldError of fieldErrorsOf(error)) {
    let target = fieldError.path;
    for (const [from, to] of Object.entries(mapping.rename ?? {})) {
      if (target.startsWith(from)) {
        target = `${to}${target.slice(from.length)}`;
        break;
      }
    }
    const root = target.split('.')[0] ?? target;
    if (!mapping.known.includes(root)) continue;
    setError(target as Path<T>, { type: 'server', message: fieldError.message });
    mapped.add(fieldError.path);
  }
  return mapped;
}
